import React, { useState, useEffect } from "react"
import Header from "../../../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import { Box, Grid, Card, CardContent, Typography } from "@mui/material"

import BackIcon from "../../../../components/BackIcon"

import { NavLink, useNavigate, useLocation } from "react-router-dom"
import fetchwrapper from "../../../../services/interceptors/fetchwrapper"
import DatagridBuscarEjecutar from "../../components/DatagridBuscarEjecutar"
import CustomBackdrop from "../../../../components/CustomBackdrop"

const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))

const StyledIcons = styled(NavLink)(({ theme }) => ({
  height: 250,
  width: 250,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.primary,
  border: "1px solid #ddd",
  cursor: "pointer",

  "& img": {
    width: "128px",
  },
}))

const StyledTextIcon = styled("div")(({ theme }) => ({
  fontSize: "18px",
  marginTop: "10px",
  fontWeight: "bolder",
}))

const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})
const EjecutarBuscarPaletizacion = () => {
  const location = useLocation()
  const [dataFiltered, setDataFiltered] = useState([])
  const [isLoadingFiltrarBusqueda, setIsLoadingFiltrarBusqueda] = useState(false)

  const filtrarBusqueda = async () => {
    try {
      setIsLoadingFiltrarBusqueda(true)
      const options = {
        method: "POST",
        body: JSON.stringify({
          ...location.state,
        }),
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      }

      // Detect what api is calling
      const typeOfFilter = location?.state?.type
      let apiUrl = ""
      switch (typeOfFilter) {
        case "barcodePallet":
          apiUrl = "/paletizacion/getAllFiltrosBuscarXPallet"
          break
        case "barcodeLote":
          apiUrl = "/paletizacion/getAllFiltrosBuscarxLote"
          break
        default:
          apiUrl = "/paletizacion/getAllFiltrosBuscar"
          break
      }
      let response = await fetchwrapper(apiUrl, options)
      response = await response.json()

      setDataFiltered(response.data)

      console.log(location.state, response)
    } catch (err) {
      alert("Error en filtrar los datos")
    } finally {
      setIsLoadingFiltrarBusqueda(false)
    }
  }

  useEffect(() => {
    filtrarBusqueda()
  }, [])
  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Paletizacion</b>
        </div>

        <CustomBackdrop isLoading={isLoadingFiltrarBusqueda} />

        <Box className={StyledRoot}>
          {dataFiltered.length === 0 ? (
            <div style={{ textAlign: "center" }}>No existen registros</div>
          ) : (
            dataFiltered.map((pallet, index) => {
              return (
                <DatagridBuscarEjecutar
                  data={pallet}
                  setData={setDataFiltered}
                  filtrarBusqueda={filtrarBusqueda}
                  key={index}
                />
              )
            })
          )}
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default EjecutarBuscarPaletizacion

// {
//     "pallets": [
//         {
//             "label": "587",
//             "value": "587",
//             "__isNew__": true
//         },
//         {
//             "label": "425",
//             "value": "425",
//             "__isNew__": true
//         },
//         {
//             "label": "785",
//             "value": "785",
//             "__isNew__": true
//         }
//     ],
//     "lotes": [
//         {
//             "label": "pk-586-7",
//             "value": "pk-586-7",
//             "__isNew__": true
//         },
//         {
//             "label": "tf-875-8",
//             "value": "tf-875-8",
//             "__isNew__": true
//         }
//     ],
//     "bodegas": [
//         {
//             "label": "* MERCATTI BODEGA GENERAL *",
//             "value": "01"
//         },
//         {
//             "label": "BACINI",
//             "value": "04"
//         },
//         {
//             "label": "MEDIAGNOSTIC",
//             "value": "08"
//         },
//         {
//             "label": "MERCATTI ESTHETIC S.A.",
//             "value": "12"
//         }
//     ],
//     "productos": [
//         {
//             "label": "000036010 BOLSA PARA EL RECIPIENTE DE SUCCIÓN DE FLUIDOS 1000ML",
//             "value": "100716"
//         },
//         {
//             "label": "00 PREP 2ml",
//             "value": "100158"
//         },
//         {
//             "label": "000036011 BOLSA PARA EL RECIPIENTE DE SUCCIÓN DE FLUIDOS 2000ML",
//             "value": "100714"
//         }
//     ],
//     "opcionPallet": "pallet"
// }
